<script>
export default {
    props: ['backgroundColor']
}
</script>
<template>
<span :style="{'background-color': backgroundColor}"></span>
</template>

<style scoped>
    span {
        width: 100%;
        display:block;
        height: 4px;
        border-radius: 5px;
        transition: ease-in-out 0.3s;
    }
</style>